import { styledComponent, Box } from '@hermes/web-components'

export const Container = styledComponent(Box)(({ theme }) => ({
  marginTop: '48px',
  paddingTop: '23px',
  marginBottom: '50px',
  borderTop: `1px solid ${theme.palette.neutral[200]}`,

  [theme.breakpoints.up('md')]: {
    marginBottom: '100px'
  },
  '.swiper': {
    padding: '0 16px',
    margin: '0 -16px'
  }
}))
